




























import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin, inAppAlertLogin, WechatLogin } from '@/common/ts/common';
import { Popup, Toast, Checkbox } from 'vant';
import SlideVerify from './SlideVerify.vue';
import { webSendMsg } from '@/api/api';

Vue.use(Popup)
  .use(Toast)
  .use(Checkbox);
@Component({
  components: {
    SlideVerify,
  },
})
export default class BindPhone extends Vue {
  phone: string = '';
  checked: boolean = false;
  SlideShow: boolean = false;

  mounted() {
    const unionid = window.localStorage.getItem('unionid');
    if (isWeiXin() && !unionid) {
      WechatLogin();
    }
    const token = window.gettoken();
    if (window.udid && (token === 'null' || !token)) {
      inAppAlertLogin();
    }
  }
  nextStep() {
    if (!this.checked) {
      Toast('请阅读并同意用户协议');
    } else {
      if (this.phone === '') {
        Toast('请输入手机号');
        return false;
      } else if (!/^1[345789][0-9]{9}$/.test(this.phone)) {
        Toast('手机号码不正确，请重新输入');
        return false;
      } else {
        this.SlideShow = true;
      }
    }
  }
  getSlideData(e: any) {
    const data = {
      phone: this.phone,
      sessionid: e.csessionid,
      sig: e.sig,
      token: e.token,
      scene: e.scene,
      smsType: 2,
    };

    webSendMsg(data).then((res) => this.enterMessageLoginPage(res));
    this.SlideShow = false;
    // this.$router.push(`code?phone="${this.phone}"`);
  }
  enterMessageLoginPage(res: any) {
    if (res.statusCode === 200) {
      Toast('短信发送成功');
      setTimeout(() => {
        this.$router.push({
          path: 'code',
          query: { phone: this.phone, url: this.$route.query.url as string },
        });
      }, 2000);
    } else {
      Toast(res.message);
      setTimeout(() => {
        this.$router.go(0);
      }, 2000);
    }
  }
}
